<script lang="ts">
	import type { SvelteAsr } from 'types/common'
	import type { AsrTabs } from './configuration'
	import type { i18n } from 'types/common'

	import { AsrNavTabBar } from '@isoftdata/svelte-nav-tab-bar'
	import { getContext } from 'svelte'

	interface Props {
		hasVisibleChildState?: boolean
		childStates?: AsrTabs
		asr: SvelteAsr
	}

	let { hasVisibleChildState = false, childStates = [], asr }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<div class="card mb-3">
	<div class="card-header">
		<div>
			<p class="h4">
				<i class="fas fa-cog fa-fw me-1"></i><span class="d-none d-sm-inline-block"
					>{translate('common:configuration', 'Configuration')}</span
				>
			</p>
			{#if hasVisibleChildState}
				<AsrNavTabBar
					{asr}
					breakpoint="md"
					tabs={childStates}
				/>
			{/if}
		</div>
	</div>
	<div class="card-body">
		{#if hasVisibleChildState}
			<uiView></uiView>
		{:else}
			<div class="p-5 mb-4 bg-body-secondary rounded-3">
				<h1 class="display-4 small-2-rem-font">
					<i class="fa-solid fa-triangle-exclamation me-sm-3"></i>
					{translate('configuration.noConfigurationOptionsAvailable.', 'No configuration options available.')}
				</h1>
				<p class="lead">
					{translate(
						'configuration.youDoNotHavePermissionForAnyConfigurationOptions.',
						'You do not have permission for any configuration options.',
					)}
					{translate(
						'configuration.contactYourAdministratorIfYouThinkThisIsInError.',
						'Contact your administrator if you think this is in error.',
					)}
				</p>
			</div>
		{/if}
	</div>
</div>
